// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__3UCVt","gradient":"home_gradient__3AEjK","logo":"home_logo__2idNL"};